import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Modal from '@material-ui/core/Modal';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
    maxHeight: '100%',
    overflow: 'auto',
  };
}

const useStyles = makeStyles((theme) => ({
  paper: (paperStyles = {}) => ({
    position: 'absolute',
    width: '60%',
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[2],
    outline: 'none',
    padding: theme.spacing(2),
    ...paperStyles,
    [theme.breakpoints.down('sm')]: {
      width: '80%',
    },
  }),
}));

export default function SimpleModal(props) {
  // getModalStyle is not a pure function, we roll the style only on the first render
  const [openModal, setOpenModal] = React.useState(false);
  const {
    open = openModal,
    paperStyles = {},
    modalProps = {},
    onChange = setOpenModal,
    heading = '',
    headingProps = { variant: 'h4' },
    closeButtonProps = { size: 'small' },
  } = props;
  const classes = useStyles(paperStyles);
  const [modalStyle] = React.useState(getModalStyle);

  const handleClose = () => {
    onChange(false);
  };

  return (
    <Modal
      aria-labelledby="modal-title"
      aria-describedby="simple-modal-description"
      open={open}
      onClose={handleClose}
      {...modalProps}
    >
      <div style={modalStyle} className={classes.paper}>
        <Grid container>
          <Grid item xs>
            {heading && (
              <Typography id="modal-title" {...headingProps}>
                {heading}
              </Typography>
            )}
          </Grid>
          <Grid item>
            <IconButton onClick={handleClose} {...closeButtonProps}>
              <CloseIcon fontSize={closeButtonProps.size} />
            </IconButton>
          </Grid>
        </Grid>
        <div id="simple-modal-description">{props.children}</div>
        <SimpleModal />
      </div>
    </Modal>
  );
}
